angular
.module('app.views')
.controller('SuppressedEmailFormController', function($scope, $location, $modalInstance, $filter, SuppressedEmail){

  $scope.isSaving = false;
  $scope.email = {
    email: '',
    reason: ''
  };

  $scope.ok = function() {
    $scope.isSaving = true;

    $scope.email.email = $filter('lowercase')($scope.email.email);
    return SuppressedEmail.save($scope.email,
      e => $modalInstance.close(e),
      function(err){
        alert('Error creating suppressed email.');
      }
    );
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});


// WEBPACK FOOTER //
// ./views/suppressed_email/suppressed_email_form_controller.js